var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('main',{staticClass:"main box1200"},[_c('div',{staticClass:"content-container"},[_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-content box1200"},[_c('h1',[_vm._v("医保业务查询（秦州区）")])])])
}]

export { render, staticRenderFns }